import PinIcon from '@repo/ui/src/components/Icons/PinIcon';
import ShipmentIcon from '@repo/ui/src/components/Icons/ShipmentIcon';
import AssemblyIcon from '@repo/ui/src/components/Icons/AssemblyIcon';
import AccessoriesIcon from '@repo/ui/src/components/Icons/AccessoriesIcon';
import { classNames } from '@repo/ui/src/utils/classNames';
import Markdown from '@repo/ui/src/components/Markdown';

export interface Props {
  dark?: boolean;
  purchaseOptions?: PurchaseOptionsProps;
}

export interface PurchaseOptionsProps {
  title: string;
  subtitle: string;
  purchaseOptions: Array<{
    icon: string;
    content: string;
  }>;
}

const iconMap: Record<string, React.ComponentType> = {
  pin: PinIcon,
  shipment: ShipmentIcon,
  assembly: AssemblyIcon,
  accessories: AccessoriesIcon,
};

const PurchaseOptions = ({ dark = false, purchaseOptions }: Props) => {
  const getIcon = (iconName: string) => {
    const IconComponent = iconMap[iconName.toLowerCase()];
    return IconComponent ? <IconComponent /> : null;
  };

  return (
    <div
      className={classNames(
        'tra-text-body-2 grid gap-y-4 md:gap-y-6 p-4 md:p-6',
        dark ? 'bg-neutral-600 text-white' : 'bg-warm-200',
      )}
    >
      <div className="grid gap-y-4">
        <h6 className="tra-text-web-heading-6 uppercase">{purchaseOptions?.title}</h6>
        <hr
          className={classNames('border-2 w-10', dark ? 'border-brand-200' : 'border-brand-300')}
        />
        <p className="tra-text-web-body-l m-0">{purchaseOptions?.subtitle}</p>
      </div>

      <ul className="grid gap-y-4 list-none p-0 m-0">
        {purchaseOptions?.purchaseOptions?.map(({ icon, content }) => (
          <li key={content} className="flex items-start gap-x-3">
            <span className="w-6 flex justify-center">{getIcon(icon)}</span>
            <p className="tra-text-web-body-l m-0">
              <Markdown>{content}</Markdown>
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PurchaseOptions;
